import React, { FC, useState }     from 'react';
import { Header }                  from 'semantic-ui-react';
import { ActivityRecurrenceLabel } from './ActivityRecurrenceLabel';

interface Props {
	isRecurrence?: boolean,
}

const defaultProps: Props = {
	isRecurrence: true,
}

const ActivityRecurrenceSubHeader: FC<Props> = ( props ) => {
	
	return <Header as={ 'h6' } sub={ true } content={ <ActivityRecurrenceLabel isRecurrence={ props.isRecurrence } withContainer={ false }/> } color={ 'grey' }/>;
};

ActivityRecurrenceSubHeader.defaultProps = defaultProps;

export { ActivityRecurrenceSubHeader }
